module.exports = __webpack_public_path__ + "img/advertise1.675f09c6.jpeg";